import { ASSET_TYPE } from '@/types/asset';
import type { AssetType } from '@/features/GlobalSearch/types/index';

// Time unit constants (in milliseconds)
const ONE_SECOND_MS = 1000;
const ONE_MINUTE_MS = ONE_SECOND_MS * 60;
const ONE_HOUR_MS = ONE_MINUTE_MS * 60;

export const PLACEHOLDER_TEXTS: Record<AssetType, string> = {
  music: 'Search mood, genre, or any keyword',
  sfx: 'Search for sound effects',
  motion: 'Search by type, theme, or style',
  stock_footage: 'Search theme, character, or moment',
  luts: 'Search cinematic, creator, or mood',
};

export const POPULAR_SEARCHES: Record<AssetType, string[]> = {
  music: ['upbeat', 'cinematic', 'happy', 'ambient', 'epic'],
  sfx: ['impact', 'whoosh', 'nature', 'footsteps', 'digital'],
  motion: ['intro', 'transition', 'logo', 'background', 'titles'],
  [ASSET_TYPE.STOCK_VIDEO]: [
    'nature',
    'city',
    'business',
    'travel',
    'abstract',
  ],
  luts: ['cinematic', 'creator', 'movie', 'professional', 'creative'],
};

export const CACHE_TIMES = {
  STALE_TIME: ONE_HOUR_MS,
  GC_TIME: ONE_HOUR_MS * 2,
};

/** Time window (ms) to consider a search as "recent" for result page tracking */
export const RECENT_SEARCH_THRESHOLD_MS = ONE_SECOND_MS * 10;

/** Animation timing for search overlay */
export const OVERLAY_ANIMATION = {
  DURATION_SECONDS: 0.15,
  /** Cubic bezier easing curve for smooth overlay fade (ease-out-cubic variant) */
  EASING: [0.33, 1, 0.68, 1] as const,
};
